import React from "react";
import "./Footer.css";
import instagram_icon from "../Assets/Assets/instagram_icon.png";
import footer_logo from "../Assets/Assets/logo_big.png";
import pintester_icon from "../Assets/Assets/pintester_icon.png";
import whastsapp_icon from "../Assets/Assets/whatsapp_icon.png";
const Footer = () => {
  return (
    <div className="footer">
      <div className=" footer-logo">
        <img src={footer_logo} alt="" />
        <p> SHOPPER</p>
      </div>
      <ul className="footer-links">
        <li>Company </li>
        <li>Products</li>
        <li>Offices</li>
        <li>About</li>
        <li>Contact</li>
      </ul>
      <div className="footer-social-icon">
        <div className="footer-icons-container">
          <img src={instagram_icon} alt="" />
        </div>

        <div className="footer-icons-container">
          <img src={pintester_icon} alt="" />
        </div>
        <div className="footer-icons-container">
          <img src={whastsapp_icon} alt="" />
        </div>
      </div>

      <div className="footer-copyright">
        <hr />
        <p> Copyright @ 2023 -All Right Reserved.</p>
      </div>
    </div>
  );
};

export default Footer;
